import { render, staticRenderFns } from "./model_71.vue?vue&type=template&id=e8a1c1fe&scoped=true"
import script from "./model_71.vue?vue&type=script&lang=js"
export * from "./model_71.vue?vue&type=script&lang=js"
import style0 from "./model_71.vue?vue&type=style&index=0&id=e8a1c1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a1c1fe",
  null
  
)

export default component.exports